<template>
  <div class="youtaofang">
    <topTitle title="柏庭荟" :list="list" :newData="newData" :ContentStatus="ContentStatus" :remakTitle="remakTitle"></topTitle>
    <p class="top_p" v-if="ContentStatus==false">
     柏庭荟运动俱乐部成立于2017年7月29日。自俱乐部成立以来，现已聘任3名理事，并组织了《叮铃铃铃，重返校园体育课》、《这年花开月正圆》钱湖柏庭欢乐游园会等多次有趣的活动，叔叔阿姨们参与热情高涨。希望叔叔阿姨们能多多参与运动，保持健康好身体。
    </p>
    <p class="top_p" style="margin:0" v-if="ContentStatus==false">
    《钱湖柏庭重返校园体育课，热血正燃！》
    </p>
      <p class="top_p" style="margin:0" v-if="ContentStatus==false">
    9月9日，教师来临前夕，钱湖柏庭示范区里，叮铃铃铃-重返校园体育课，一场教师节特别活动正在欢笑上演。
    </p>
     <div class="item_img">
      <img src="../../assets/image/party/yundong_1.png" alt="" />
    </div>
     <p class="top_p" style="margin:0" v-if="ContentStatus==false">
   此次，柏庭荟贴心地为每一个同学都准备了一条带有青春记忆的红领巾。带上这条阔别已久的红领巾，青春的回忆仿佛就在昨日。 同学们纷纷开心地合照，留下与红领巾之间的欢乐回忆。
    </p>
     <div class="item_img">
      <img src="../../assets/image/party/yundong_2.png" alt="" />
    </div>
       <p class="top_p" style="margin:0" v-if="ContentStatus==false">
还记得上学时的那位体育老师吗？高高的？帅帅的？并且活力四射？柏庭荟按照这高标准为同学找了一位高颜值体育老师！叮铃铃铃，体育课这就开始啦！立正，稍息，列队行……一步步地重复着当年体育课的步骤，咱们班的人数可真不少。看来体育课，永远是所有课程中最受欢迎的一门。
    </p>
     <div class="item_img">
      <img src="../../assets/image/party/yundong_3.png" alt="" />
    </div>
      <p class="top_p" style="margin:0" v-if="ContentStatus==false">
首先由体育课代表柏庭荟运动俱乐部理事——沃亚华同学为本次体育课做精彩致辞。接下来，体育课的乒乓考核马上就要开始啦！同学们排好队，毫无惧色，一个个球技都是杠杠的，轻松过考核。这种简单的乒乓球小游戏，果然都是小Case，同学们迫不及待地开始玩起了1对1的PK。
    </p>
     <div class="item_img">
      <img src="../../assets/image/party/yundong_4.png" alt="" />
    </div>
      <p class="top_p" style="margin:0" v-if="ContentStatus==false">
本次体育课，柏庭荟还为同学们增加了一项时尚的新内容——桌球！听完了体育老师讲解，同学们都牢牢掌握了动作要领，并开始亲身尝试。姿势要帅，动作要酷！学桌球的精髓都在这八个字里，没多久，同学们就迅速上手了，两两PK，玩得不亦乐乎！
    </p>
     <div class="item_img">
      <img src="../../assets/image/party/yundong_5.png" alt="" />
    </div>
     <p class="top_p" style="margin:0" v-if="ContentStatus==false">
叮铃铃铃……在一片意犹未尽中，体育课迎来了下课铃声。钱湖柏庭祝所有老师们教师节快乐！心态永远和在校园一样年轻！
    </p>
    
    <!-- <div class="item_bd" v-if="ContentStatus==false">
      <img :src="item.img" alt="" v-for="(item, key) in list2" :key="key" />
    </div>
     <div href="" class="navGet" @click="getHtml('3')" v-if="ContentStatus==false">“最美东钱湖”老年摄影大赛暨钱湖柏庭老年摄影俱乐部成立</div>
     <p v-html="dataContent" v-if="ContentStatus"></p> -->
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
     list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
         {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
         {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
         {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
         {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        }
      ],
      newData: 10,
      list2: [
        {
          img: require("../../assets/image/party/item_1.png"),
        },
        {
          img: require("../../assets/image/party/item_2.png"),
        },
        {
          img: require("../../assets/image/party/item_3.png"),
        },
      ],
      dataContent:'',
      ContentStatus:false,
      remakTitle:'',
    };
  },
  methods: {
    getHtml(e){
       this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
  
    }
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {
   
  },
};
</script>
<style scoped="scoped">
p{
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet{
  display: inline-block;
font-size: 32px;
font-family: PingFang SC;
font-weight: 500;
text-decoration: underline;
color: #3F674B;
line-height: 54px;
text-align: left;
margin-top: 0.6rem;
cursor: pointer;
}
.item_img{
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img img{
 width: 11.975rem;
/* height: 8.9875rem; */
}
</style>